import { type VoiceMessageStatus } from "./types";
import { create } from 'zustand';

interface VoicePlayerStore {
  messagesIdStatus: Record<string, VoiceMessageStatus>;
  setStatus: (id: string, status: VoiceMessageStatus) => void;
  resetOthers: (excludeMessageId: string) => void;
}

export const useVoicePlayerStore = create<VoicePlayerStore>((set, get) => ({
  messagesIdStatus: {},

  setStatus: (id, status) => {
    set(state => ({
      messagesIdStatus: { ...state.messagesIdStatus, [id]: status },
    }));
  },

  resetOthers: (excludeMessageId) => {
    const { messagesIdStatus } = get();
    const newStatuses = { ...messagesIdStatus };
    Object.keys(newStatuses).forEach(id => {
      if (id !== excludeMessageId && newStatuses[id] !== 'pending') {
        newStatuses[id] = 'default';
      }
    });

    set({ messagesIdStatus: newStatuses });
  },
}));
